(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-upsell"] && !Shopify.designMode) return;
  try {
    
(function(){
  function run(){
    var sec=document.querySelector('.cupsell');
    if(!sec)return;
    var card=sec.querySelector('[data-cupsell-card]');
    var checkout=document.querySelector('.cart__checkout');
    if(card&&checkout&&checkout.parentNode){
      checkout.parentNode.insertBefore(card,checkout);
      card.classList.add('cupsell__card--relocated');
      sec.classList.add('is-moved');
      requestAnimationFrame(function(){requestAnimationFrame(function(){card.classList.add('is-in');});});
    }
  }
  if(document.readyState!=='loading'){run();}
  else{document.addEventListener('DOMContentLoaded',run);}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('header.zh');
    if (!header) return;

    if (header.getAttribute('data-reveal-on-scroll') === 'true') {
      var sections = document.querySelectorAll('main .shopify-section, #MainContent .shopify-section, body > .shopify-section');
      var trigger = null;
      for (var i = 0; i < sections.length; i++) {
        var el = sections[i];
        if (el.querySelector('header.zh') || el.querySelector('.zh-mobile')) continue;
        if (el.classList.contains('shopify-section-group-header-group')) continue;
        if (trigger === null) {
          trigger = { first: el, second: null };
        } else if (!trigger.second) {
          trigger.second = el;
          break;
        }
      }

      var show = function () { header.classList.add('is-visible'); };
      var hide = function () { header.classList.remove('is-visible'); };

      if (trigger && trigger.second && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.boundingClientRect.top <= 0) { show(); } else { hide(); }
          });
        }, { threshold: 0, rootMargin: '0px 0px -100% 0px' });
        io.observe(trigger.second);
      } else {
        var SHOW_AFTER_PX = (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ? 320 : 560;
        var ticking = false;
        var update = function () {
          if (window.scrollY > SHOW_AFTER_PX) { show(); } else { hide(); }
          ticking = false;
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
        }, { passive: true });
        update();
      }
    }

    var burger = document.querySelector('.zh__burger');
    var mobileMenu = document.getElementById('zhMobileMenu');
    if (burger && mobileMenu) {
      var closeMenu = function () {
        burger.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('is-open');
        window.setTimeout(function () {
          if (burger.getAttribute('aria-expanded') === 'false') mobileMenu.hidden = true;
        }, 320);
      };
      var openMenu = function () {
        mobileMenu.hidden = false;
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            mobileMenu.classList.add('is-open');
          });
        });
        burger.setAttribute('aria-expanded', 'true');
      };
      burger.addEventListener('click', function () {
        var isOpen = burger.getAttribute('aria-expanded') === 'true';
        if (isOpen) { closeMenu(); } else { openMenu(); }
      });
      mobileMenu.addEventListener('click', function (e) {
        if (e.target.tagName === 'A') closeMenu();
      });
      document.addEventListener('click', function (e) {
        if (burger.getAttribute('aria-expanded') !== 'true') return;
        if (mobileMenu.contains(e.target) || burger.contains(e.target)) return;
        closeMenu();
      });
      window.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') closeMenu();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-bundle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('[data-bndl]');
  if(!root)return;
  var radios=root.querySelectorAll('.bndl__radio');
  var cta=root.querySelector('[data-bndl-cta]');
  var priceEl=root.querySelector('[data-bndl-price]');
  function update(r){
    if(priceEl)priceEl.textContent=r.getAttribute('data-price')||'';
    if(cta){var u=r.getAttribute('data-url');if(u)cta.setAttribute('href',u);}
  }
  radios.forEach(function(r){r.addEventListener('change',function(){if(r.checked)update(r);});});
  var checked=root.querySelector('.bndl__radio:checked');
  if(checked)update(checked);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-deal"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MAP = [
    { m: 'Night System', l: 'Night System Bundle' },
    { m: 'Full Kit', l: 'Full Kit Bundle' }
  ];
  function tag(){
    var slides = document.querySelectorAll('.mp__slide');
    for(var j=0;j<slides.length;j++){
      var sl = slides[j];
      if(sl.querySelector('.mp__packlabel')) continue;
      var img = sl.querySelector('img');
      if(!img) continue;
      var alt = img.getAttribute('alt') || '';
      for(var i=0;i<MAP.length;i++){
        if(alt.indexOf(MAP[i].m) !== -1){
          var el = document.createElement('span');
          el.className = 'mp__packlabel';
          el.textContent = MAP[i].l;
          sl.appendChild(el);
          break;
        }
      }
    }
  }
  if(document.readyState !== 'loading'){ tag(); } else { document.addEventListener('DOMContentLoaded', tag); }
  setTimeout(tag, 1200);
  setTimeout(tag, 3000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-founders"] && !Shopify.designMode) return;
  try {
    
(function(){
  var SEL = 'a[href="#shopify-section-lp-bundle"], a[href="#bundle"], a[href="#buy"], .snote__cta-band a, .snote__cta, .siy__cta, .ppromise__atc, .rlf__cta, .flt__cta';
  function toBundle(e){
    var b = document.querySelector('.bndl');
    if(!b){ return; }
    e.preventDefault();
    e.stopPropagation();
    if(e.stopImmediatePropagation){ e.stopImmediatePropagation(); }
    var off = 88;
    var y = b.getBoundingClientRect().top + window.pageYOffset - off;
    if(y < 0){ y = 0; }
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
  document.addEventListener('click', function(e){
    var el = e.target;
    if(!el || !el.closest){ return; }
    var hit = el.closest(SEL);
    if(hit){ toBundle(e); }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-product-chapter"] && !Shopify.designMode) return;
  try {
    

  (function () {
    document.querySelectorAll('.mp').forEach(function (root) {
      root.querySelectorAll('[data-qty-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = root.querySelector('.mp__qty-input');
          if (!input) return;
          var current = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          input.value = btn.dataset.qtyAction === 'increase' ? current + 1 : Math.max(min, current - 1);
        });
      });

      var slides = root.querySelector('[data-mp-slides]');
      if (slides) {
        var thumbs = root.querySelectorAll('.mp__thumb[data-mp-thumb]');
        var slideEls = root.querySelectorAll('.mp__slide[data-mp-slide]');
        var counterEl = root.querySelector('[data-mp-counter-current]');
        var scrollToIdx = function (idx) { slides.scrollTo({ left: idx * slides.clientWidth, behavior: 'smooth' }); };
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var idx = parseInt(thumb.dataset.mpThumb, 10);
            scrollToIdx(idx);
            thumbs.forEach(function (t) { t.classList.remove('is-active'); });
            thumb.classList.add('is-active');
            if (counterEl) counterEl.textContent = idx + 1;
          });
        });
        var syncActive = function () {
          var idx = Math.round(slides.scrollLeft / slides.clientWidth);
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
          if (counterEl) counterEl.textContent = idx + 1;
        };
        var st = false;
        slides.addEventListener('scroll', function () {
          if (!st) { window.requestAnimationFrame(function () { syncActive(); st = false; }); st = true; }
        }, { passive: true });

        if ('IntersectionObserver' in window) {
          var slideIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              entry.target.classList.toggle('is-in-view', entry.intersectionRatio > 0.6);
            });
          }, { root: slides, threshold: [0, 0.6, 1] });
          slideEls.forEach(function (el) { slideIO.observe(el); });
        }
      }

      var mainStage = root.querySelector('#mpMain');
      var magnifier = root.querySelector('[data-mp-magnifier]');
      if (mainStage && magnifier && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var activeImg = function () {
          var active = mainStage.querySelector('.mp__slide.is-in-view .mp__main-image') || mainStage.querySelector('.mp__main-image');
          return active;
        };
        var zoom = 2.6;
        mainStage.addEventListener('mousemove', function (e) {
          var img = activeImg();
          if (!img) return;
          var rect = mainStage.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var y = e.clientY - rect.top;
          var xPct = (x / rect.width) * 100;
          var yPct = (y / rect.height) * 100;
          var lensSize = magnifier.offsetWidth || 152;
          magnifier.style.left = (x - lensSize / 2) + 'px';
          magnifier.style.top = (y - lensSize / 2) + 'px';
          magnifier.style.backgroundImage = 'url(' + (img.dataset.mpSrc || img.src) + ')';
          magnifier.style.backgroundSize = (rect.width * zoom) + 'px ' + (rect.height * zoom) + 'px';
          magnifier.style.backgroundPosition = (-(x * zoom - lensSize / 2)) + 'px ' + (-(y * zoom - lensSize / 2)) + 'px';
        });
        mainStage.addEventListener('mouseenter', function () { magnifier.classList.add('is-visible'); });
        mainStage.addEventListener('mouseleave', function () { magnifier.classList.remove('is-visible'); });
      }

      var lightbox = document.querySelector('[data-mp-lightbox]');
      var expandBtn = root.querySelector('[data-mp-expand]');
      if (lightbox && expandBtn) {
        var lbTrack = lightbox.querySelector('[data-mp-lightbox-track]');
        var lbClose = lightbox.querySelector('[data-mp-lightbox-close]');
        var openLightbox = function () {
          var idx = 0;
          var activeThumb = root.querySelector('.mp__thumb.is-active');
          if (activeThumb) idx = parseInt(activeThumb.dataset.mpThumb, 10) || 0;
          lightbox.classList.add('is-open');
          lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          if (lbTrack) {
            window.requestAnimationFrame(function () {
              lbTrack.scrollLeft = idx * lbTrack.clientWidth;
            });
          }
        };
        var closeLightbox = function () {
          lightbox.classList.remove('is-open');
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        };
        expandBtn.addEventListener('click', openLightbox);
        if (lbClose) lbClose.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
        });
      }

      var atcBtn = root.querySelector('[data-mp-atc]');
      var sticky = root.querySelector('.mpsticky');
      if (sticky && atcBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { sticky.classList.toggle('is-hidden', entry.isIntersecting); });
        }, { threshold: 0 }).observe(atcBtn);
      }

      var variantsScript = root.querySelector('[data-mp-variants]');
      var optionsScript = root.querySelector('[data-mp-option-names]');
      var idInput = root.querySelector('[data-mp-variant-id]');
      var priceEl = root.querySelector('[data-mp-price]');
      if (variantsScript && optionsScript && idInput) {
        var variants = JSON.parse(variantsScript.textContent);
        var optionNames = JSON.parse(optionsScript.textContent);
        var formatMoney = function (cents) {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
          return (cents / 100).toFixed(2);
        };
        var update = function () {
          var selected = optionNames.map(function (name) {
            var radio = root.querySelector('input[name="options[' + name + ']"]:checked');
            return radio ? radio.value : null;
          });
          var match = variants.find(function (v) { return v.options.every(function (val, i) { return val === selected[i]; }); });
          if (!match) return;
          idInput.value = match.id;
          if (priceEl) priceEl.textContent = formatMoney(match.price);
        };
        root.querySelectorAll('.mp__option-radio').forEach(function (radio) { radio.addEventListener('change', update); });
      }
    });
  }());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-see-you"] && !Shopify.designMode) return;
  try {
    
(function(){
  var el=document.querySelector('[data-siy]');
  if(!el)return;
  if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  el.classList.add('siy--anim');
  if(!('IntersectionObserver' in window)){el.classList.add('is-in');return;}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){el.classList.add('is-in');io.disconnect();}});},{threshold:0.25});
  io.observe(el);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-zuzunest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.cart').forEach(function (root) {
      var form = root.querySelector('.cart__form');
      if (!form) return;

      // Quantity ± buttons
      root.querySelectorAll('[data-qty-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = btn.parentElement.querySelector('.cart__qty-input');
          if (!input) return;
          var current = parseInt(input.value, 10) || 0;
          var min = parseInt(input.min, 10) || 0;
          var next = btn.dataset.qtyAction === 'increase' ? current + 1 : Math.max(min, current - 1);
          input.value = next;
          form.submit();
        });
      });

      // Auto-submit when quantity is edited directly
      root.querySelectorAll('.cart__qty-input').forEach(function (input) {
        input.addEventListener('change', function () {
          form.submit();
        });
      });

      // Sticky mobile checkout bar: show it while the in-flow button is off screen,
      // hide it once the real button scrolls into view so the two never overlap.
      var sticky = root.querySelector('[data-cart-sticky]');
      var inflowBtn = root.querySelector('[data-cart-checkout]');
      if (sticky && inflowBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          });
        }, { threshold: 0 });
        io.observe(inflowBtn);
      }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-zuzunest"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mp').forEach(function (root) {
      root.querySelectorAll('[data-qty-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = root.querySelector('.mp__qty-input');
          if (!input) return;
          var current = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          input.value = btn.dataset.qtyAction === 'increase' ? current + 1 : Math.max(min, current - 1);
        });
      });

      var slides = root.querySelector('[data-mp-slides]');
      if (slides) {
        var thumbs = root.querySelectorAll('.mp__thumb[data-mp-thumb]');
        var slideEls = root.querySelectorAll('.mp__slide[data-mp-slide]');
        var counterEl = root.querySelector('[data-mp-counter-current]');
        var scrollToIdx = function (idx) { slides.scrollTo({ left: idx * slides.clientWidth, behavior: 'smooth' }); };
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var idx = parseInt(thumb.dataset.mpThumb, 10);
            scrollToIdx(idx);
            thumbs.forEach(function (t) { t.classList.remove('is-active'); });
            thumb.classList.add('is-active');
            if (counterEl) counterEl.textContent = idx + 1;
          });
        });
        var syncActive = function () {
          var idx = Math.round(slides.scrollLeft / slides.clientWidth);
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
          if (counterEl) counterEl.textContent = idx + 1;
        };
        var st = false;
        slides.addEventListener('scroll', function () {
          if (!st) { window.requestAnimationFrame(function () { syncActive(); st = false; }); st = true; }
        }, { passive: true });

        // Cinematic settle: each slide gently scales/fades into full focus
        // as it becomes the active one, rather than a hard swap.
        if ('IntersectionObserver' in window) {
          var slideIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              entry.target.classList.toggle('is-in-view', entry.intersectionRatio > 0.6);
            });
          }, { root: slides, threshold: [0, 0.6, 1] });
          slideEls.forEach(function (el) { slideIO.observe(el); });
        }
      }

      // ---- Magnifier: desktop hover only ----
      var mainStage = root.querySelector('#mpMain');
      var magnifier = root.querySelector('[data-mp-magnifier]');
      if (mainStage && magnifier && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var activeImg = function () {
          var active = mainStage.querySelector('.mp__slide.is-in-view .mp__main-image') || mainStage.querySelector('.mp__main-image');
          return active;
        };
        var zoom = 2.6;
        mainStage.addEventListener('mousemove', function (e) {
          var img = activeImg();
          if (!img) return;
          var rect = mainStage.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var y = e.clientY - rect.top;
          var xPct = (x / rect.width) * 100;
          var yPct = (y / rect.height) * 100;
          var lensSize = magnifier.offsetWidth || 152;
          magnifier.style.left = (x - lensSize / 2) + 'px';
          magnifier.style.top = (y - lensSize / 2) + 'px';
          magnifier.style.backgroundImage = 'url(' + (img.dataset.mpSrc || img.src) + ')';
          magnifier.style.backgroundSize = (rect.width * zoom) + 'px ' + (rect.height * zoom) + 'px';
          magnifier.style.backgroundPosition = (-(x * zoom - lensSize / 2)) + 'px ' + (-(y * zoom - lensSize / 2)) + 'px';
        });
        mainStage.addEventListener('mouseenter', function () { magnifier.classList.add('is-visible'); });
        mainStage.addEventListener('mouseleave', function () { magnifier.classList.remove('is-visible'); });
      }

      // ---- Fullscreen lightbox ----
      var lightbox = document.querySelector('[data-mp-lightbox]');
      var expandBtn = root.querySelector('[data-mp-expand]');
      if (lightbox && expandBtn) {
        var lbTrack = lightbox.querySelector('[data-mp-lightbox-track]');
        var lbClose = lightbox.querySelector('[data-mp-lightbox-close]');
        var openLightbox = function () {
          var idx = 0;
          var activeThumb = root.querySelector('.mp__thumb.is-active');
          if (activeThumb) idx = parseInt(activeThumb.dataset.mpThumb, 10) || 0;
          lightbox.classList.add('is-open');
          lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          if (lbTrack) {
            window.requestAnimationFrame(function () {
              lbTrack.scrollLeft = idx * lbTrack.clientWidth;
            });
          }
        };
        var closeLightbox = function () {
          lightbox.classList.remove('is-open');
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        };
        expandBtn.addEventListener('click', openLightbox);
        if (lbClose) lbClose.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && lightbox.classList.contains('is-open')) closeLightbox();
        });
      }

      var atcBtn = root.querySelector('[data-mp-atc]');
      var sticky = root.querySelector('.mpsticky');
      if (sticky && atcBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { sticky.classList.toggle('is-hidden', entry.isIntersecting); });
        }, { threshold: 0 }).observe(atcBtn);
      }

      var variantsScript = root.querySelector('[data-mp-variants]');
      var optionsScript = root.querySelector('[data-mp-option-names]');
      var idInput = root.querySelector('[data-mp-variant-id]');
      var priceEl = root.querySelector('[data-mp-price]');
      if (variantsScript && optionsScript && idInput) {
        var variants = JSON.parse(variantsScript.textContent);
        var optionNames = JSON.parse(optionsScript.textContent);
        var formatMoney = function (cents) {
          if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
          return (cents / 100).toFixed(2);
        };
        var update = function () {
          var selected = optionNames.map(function (name) {
            var radio = root.querySelector('input[name="options[' + name + ']"]:checked');
            return radio ? radio.value : null;
          });
          var match = variants.find(function (v) { return v.options.every(function (val, i) { return val === selected[i]; }); });
          if (!match) return;
          idInput.value = match.id;
          if (priceEl) priceEl.textContent = formatMoney(match.price);
        };
        root.querySelectorAll('.mp__option-radio').forEach(function (radio) { radio.addEventListener('change', update); });
      }
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pugc').forEach(function (root) {
      var vids = root.querySelectorAll('video');
      vids.forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.setAttribute('autoplay', '');
        v.setAttribute('loop', '');
        var tryPlay = function () { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } };
        tryPlay();
        v.addEventListener('canplay', tryPlay);
        v.addEventListener('loadeddata', tryPlay);
      });
      var kicks = 0;
      var iv = setInterval(function () {
        vids.forEach(function (v) { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } });
        if (++kicks >= 6) clearInterval(iv);
      }, 800);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps-sequence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSeq(stage) {
      var clips = stage.querySelectorAll('.pseq__clip');
      var vids  = stage.querySelectorAll('.pseq__clip video');
      var steps = stage.querySelectorAll('.pseq__step');
      if (!clips.length || !vids.length) return;

      var current = 0;
      var FADE = 380;
      var LEAD = 0.12;
      var watchdog = null;
      var advancing = false;

      function num(el, attr, fallback) {
        var v = parseFloat(el.getAttribute(attr));
        return isNaN(v) ? fallback : v;
      }

      function startOf(idx) {
        return Math.max(0, num(clips[idx], 'data-start', 0));
      }

      function endOf(idx) {
        var v = vids[idx];
        var declared = num(clips[idx], 'data-end', 0);
        var dur = (v.duration && isFinite(v.duration)) ? v.duration : 0;
        if (declared > 0 && (dur === 0 || declared < dur)) return declared;
        return dur;
      }

      function park(idx) {
        var v = vids[idx];
        var from = startOf(idx);
        try {
          if (Math.abs(v.currentTime - from) > 0.04) v.currentTime = from;
        } catch (e) {}
      }

      function prep(v, idx) {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.removeAttribute('loop');
        v.removeAttribute('controls');
        v.preload = 'auto';

        if (v.readyState >= 1) {
          park(idx);
        } else {
          v.addEventListener('loadedmetadata', function onMeta() {
            v.removeEventListener('loadedmetadata', onMeta);
            park(idx);
          });
          try { v.load(); } catch (e) {}
        }
      }

      for (var i = 0; i < vids.length; i++) prep(vids[i], i);

      function runProgress(idx, seconds) {
        if (!steps[idx]) return;
        var bar = steps[idx].querySelector('.pseq__prog');
        if (!bar) return;
        bar.style.transition = 'none';
        bar.style.width = '0%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            bar.style.transition = 'width ' + seconds + 's linear';
            bar.style.width = '100%';
          });
        });
      }

      function resetProgress(idx) {
        if (!steps[idx]) return;
        var bar = steps[idx].querySelector('.pseq__prog');
        if (!bar) return;
        bar.style.transition = 'none';
        bar.style.width = '0%';
      }

      function show(n) {
        var prev = current;
        var next = ((n % clips.length) + clips.length) % clips.length;

        if (watchdog) { clearTimeout(watchdog); watchdog = null; }

        current = next;
        advancing = false;

        var v = vids[next];

        // Start the incoming clip playing BEFORE swapping opacity,
        // so the fade reveals moving footage, never a frozen frame.
        park(next);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});

        clips[next].classList.add('is-active');
        if (steps[next]) steps[next].classList.add('is-active');

        if (prev !== next) {
          clips[prev].classList.remove('is-active');
          if (steps[prev]) steps[prev].classList.remove('is-active');
          resetProgress(prev);

          setTimeout(function () {
            try {
              vids[prev].pause();
              park(prev);
            } catch (e) {}
          }, FADE);
        }

        var from = startOf(next);
        var stopAt = endOf(next);
        var span = stopAt > from ? (stopAt - from) : ((v.duration || 6) - from);
        if (!(span > 0)) span = 6;

        runProgress(next, span);

        watchdog = setTimeout(function () {
          if (!advancing) { advancing = true; show(current + 1); }
        }, (span + 0.05) * 1000);
      }

      for (var k = 0; k < vids.length; k++) {
        (function (idx) {
          vids[idx].addEventListener('timeupdate', function () {
            if (idx !== current || advancing) return;
            var stopAt = endOf(idx);
            if (stopAt > 0 && this.currentTime >= stopAt - LEAD) {
              advancing = true;
              show(idx + 1);
            }
          });
          vids[idx].addEventListener('ended', function () {
            if (idx === current && !advancing) {
              advancing = true;
              show(idx + 1);
            }
          });
        })(k);
      }

      var started = false;
      function kick() {
        if (started) return;
        started = true;
        show(0);
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var e = 0; e < entries.length; e++) {
            if (entries[e].isIntersecting) { kick(); io.disconnect(); }
          }
        }, { threshold: 0.25 });
        io.observe(stage);
      } else {
        kick();
      }
    }

    var stages = document.querySelectorAll('.pseq__stage');
    for (var i = 0; i < stages.length; i++) initSeq(stages[i]);
  }());

  } catch(e) { console.error(e); }
})();
})();
